import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoConfirmarEnvio from './ContentSolicitacaoFluxoConfirmarEnvio';

const SolicitacaoFluxoConfirmarEnvio = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoConfirmarEnvio />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoConfirmarEnvio;
